import { StorageService } from 'shared/storage';

type CandidateAvailabilityStorageItem = 'timeSlotsPageVisited';

export default class CandidateAvailabilityStorage extends StorageService<CandidateAvailabilityStorageItem> {

    private static instance?: CandidateAvailabilityStorage;

    private constructor() {
        super('candidateAvailability');
    }

    public static getInstance() {
        if (!this.instance) {
            this.instance = new CandidateAvailabilityStorage();
        }

        return this.instance;
    }

    public setTimeSlotsPageVisited(value: boolean) {
        this.setItem('timeSlotsPageVisited', value);
    }

    public getTimeSlotsPageVisited(): boolean {
        return this.getItem<boolean>('timeSlotsPageVisited', false);
    }

}
